import b2bCopilotDevPlanMarkdown from '@/assets/Artifacts/b2b-copilot-dev-plan.md?raw'
import interfaceManagementCapability from './content/interface-management-capability.md?raw'
import mediaDocumentsCapability from './content/media-documents-capability.md?raw'
import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { buildSelectionSwitchBlock } from './demoSelectionSwitch.js'
import { buildFileWriteNarration, buildStepNarration } from './stepNarrationCopy.js'

/** Demo copy and trace payloads for the B2B Copilot development plan thread. */

export const B2B_COPILOT_PLAN_USER_PROMPT =
  'Connect to my github repo "company website" and read the requirement.md file in details. Summarize your understanding and suggest if there are any changes required. Create a detailed development plan.'

export const B2B_COPILOT_PLAN_THOUGHT_DETAILS = [
  `The user wants the GitHub "company website" repo connected, requirement.md read in detail, a plain-language summary, suggested changes, and a detailed development plan.`,
  `Plan of attack:

• Connect to GitHub and open the company-website repository
• Locate and read requirement.md end-to-end
• Summarize goals, features, tech stack, and constraints
• Flag gaps or ambiguities that need clarification
• Draft a phased development plan and show it in the preview panel`,
  `I'll connect to the repo and read requirement.md before summarizing and planning.`,
  `Tech stack decisions:

• Vite over Next.js — simpler setup for a demo; no SSR needed
• LangGraph 0.2.x — orchestration with typed state and conditional routing
• OpenAI — embeddings and LLM
• pgvector — vector store in PostgreSQL
• Alembic — database migrations
• SQLModel + SQLAlchemy — ORM aligned with Pydantic schemas

Timeline sketch:

• Hour 1 — Project setup, Docker, database schema + migrations
• Hours 2–3 — Synthetic data generation and ingestion pipeline
• Hours 4–5 — Core RAG functionality`,
  `Writing this up as a detailed markdown document…`,
]

export const B2B_COPILOT_PLAN_INTRO_MARKDOWN =
  "I'll connect to your GitHub repo, read requirement.md in detail, summarize my understanding, suggest any changes, and create a detailed development plan in the preview panel."

export const B2B_COPILOT_PLAN_BEFORE_WRITE_MARKDOWN =
  'Now let me write the development plan as a comprehensive markdown document:'

export const B2B_COPILOT_PLAN_AI_LOG_STEPS_INITIAL = [
  {
    durationMs: 2000,
    actionName: 'Loaded interface-management instructions',
    arguments: 'path: /DOSense/system/capabilities/interface-management/CAPABILITY.md',
    result: interfaceManagementCapability,
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Interface-management instructions are loaded, so the preview panel is available',
      'loading media-and-documents instructions',
      0,
    ),
  },
  {
    durationMs: 2000,
    actionName: 'Loaded media-and-documents instructions',
    arguments: 'path: /DOSense/system/capabilities/media-and-documents/CAPABILITY.md',
    result: mediaDocumentsCapability,
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Media and document tools are ready',
      'drafting the detailed development plan',
      1,
    ),
  },
]
